export default {
  modals: {
    delete_payment_method: {
      title: 'Ești sigur că vrei să elimini această metodă de plată?',
    },
  },
  buttons: {
    confirm: 'Confirmă',
    cancel: 'Anulează',
  },
  toasts: {
    failed_to_delete_payment_method: 'Ștergerea metodei de plată a eșuat',
    payment_method_deleted: 'Metoda de plată a fost ștearsă',
  },
};
